import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { PieChart, Pie, Cell } from 'recharts';
import './IcpSegmentation.css';
import { useNavigate } from 'react-router-dom';
import { encodeQueryParam } from '../../utils/urlUtils';

const IcpSegmentation = ({ totalclients, icpDistribution, selectedUserId }) => {
  const navigate = useNavigate();
  const COLORS = ['#F54BB1', '#F4C107', '#03BC72'];

  const data = [
    { name: 'ICP III', value: icpDistribution?.['ICP III'] ?? 0, color: COLORS[0] },
    { name: 'ICP II', value: icpDistribution?.['ICP II'] ?? 0, color: COLORS[1] },
    { name: 'ICP I', value: icpDistribution?.['ICP I'] ?? 0, color: COLORS[2] },
  ];

  const handleFilterClick = (key) => {
    const formattedKey = encodeQueryParam(key);
    const userIdParam = selectedUserId ? `&userId=${selectedUserId}` : '';
    navigate(`/clients?icp=${formattedKey}${userIdParam}`);
  };

  return (
    <Box className="icpseg-container">
      <Typography variant="h6" className="icpseg-title" sx={{ fontWeight: 'bold' }}>
        ICP Segmentation
      </Typography>

      <Box className="icpseg-inner-box">
        <Box className="icpseg-pie-wrapper">
          <PieChart width={150} height={150}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={70}
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>

          <Box className="icpseg-center-text">
            <Typography variant="h4" fontWeight="bold">
              {totalclients ?? 0}
            </Typography>
            <Typography variant="body2">Clients</Typography>
          </Box>
        </Box>

        <List className="icpseg-list">
          {data.map((item, index) => (
            <ListItem key={index} className="icpseg-list-item"
            onClick={() => handleFilterClick(item.name)}
              sx={{
                cursor: 'pointer',
                userSelect: 'none',
                '&:hover': { backgroundColor: 'rgba(87, 42, 241, 0.1)', color: '#572AF1' },
              }}
              title={`Filter clients by ${item.name}`}
            >
              <Box className="icpseg-dot" style={{ backgroundColor: item.color }} />
              <ListItemText
                primary={
                  <Box className="icpseg-list-entry">
                    <Typography component="span" className="icpseg-value"  fontWeight="bold">{item.value}</Typography>
                    <Typography component="span">{item.name}</Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default IcpSegmentation;
